var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegeterian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-1{stroke:#d00000;stroke-miterlimit:10;stroke-width:10px;}.cls-2,.cls-3{stroke:#333;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:5px;}.cls-3{stroke-width:7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265,150A115,115,0,1,1,150,35,115,115,0,0,1,265,150Z",
    transform: "translate(-30 -30)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.68,39.11",
    transform: "translate(-30 -30)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.29,114.57c1.54-1.26,3.2-2.5,5-3.7,0,0,13.78-8.27,38.39-6.5s37.6-12.2,37.6-12.2,7.09-7.48,7.48-8.47,4.33-6.69,7.68-1.18,19.48,46.26-4.73,84.65-60.23,35-60.23,35-23,3.15-39.77-19.69c0,0-14.37,15.16-17.32,21.07s-6.1,7.67-10.83,6.49-7.37-5.51-4.87-11.22a89.26,89.26,0,0,1,26.37-33.3h0C93.6,147,99.38,126.81,114.29,114.57Z",
    transform: "translate(-30 -30)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.43,167.66s42.81,9.45,80.91-48.13",
    transform: "translate(-30 -30)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegeterian);
export default __webpack_public_path__ + "static/media/vegeterian.82302934c52f884c94092474711bfeab.svg";
export { ForwardRef as ReactComponent };